import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b491cbb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "comment_header flex al ju" }
const _hoisted_2 = { class: "flex al" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "comment_item_name mr-16" }, "功能开关", -1))
const _hoisted_4 = { class: "flex al" }
const _hoisted_5 = { class: "content_box" }
const _hoisted_6 = { class: "comment_item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "comment_item_name" }, "评论库", -1))
const _hoisted_8 = { class: "comment_item_content" }
const _hoisted_9 = { class: "flex al ju" }
const _hoisted_10 = { class: "content_list" }
const _hoisted_11 = { class: "list_black" }
const _hoisted_12 = { style: {"width":"100%","height":"100%"} }
const _hoisted_13 = { class: "list_con" }
const _hoisted_14 = {
  key: 0,
  class: "item_txt item_line hove type"
}
const _hoisted_15 = { class: "item_line show_icon" }
const _hoisted_16 = { class: "comment_item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "comment_item_name" }, "身份库", -1))
const _hoisted_18 = { class: "comment_item_content" }
const _hoisted_19 = { class: "flex al ju" }
const _hoisted_20 = { class: "content_list" }
const _hoisted_21 = { class: "list_h" }
const _hoisted_22 = { class: "flex al ju item_w" }
const _hoisted_23 = { class: "flex al item_l" }
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "item_iden" }
const _hoisted_26 = { class: "flex al icon_w item_r" }
const _hoisted_27 = { class: "comment_item" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "comment_item_name" }, "发送方式", -1))
const _hoisted_29 = { class: "comment_item_content" }
const _hoisted_30 = {
  key: 0,
  class: "mt-10"
}
const _hoisted_31 = {
  key: 1,
  class: "mt-10"
}
const _hoisted_32 = { class: "save" }
const _hoisted_33 = { class: "flex al" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "comment_item_name" }, "请输入内容：", -1))
const _hoisted_35 = { class: "flex al" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "comment_item_name" }, "请输入内容：", -1))
const _hoisted_37 = { class: "flex" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "comment_item_name mr-16" }, "头像：", -1))
const _hoisted_39 = { class: "flex al mt-10" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "comment_item_name mr-16" }, "姓名：", -1))

import { reactive, ref, onMounted, computed, nextTick } from 'vue';
import { FileInfo, IDataList, ICommConfig } from './type';
import { List, Radio, InputNumber, message, Upload, Modal, Input } from 'ant-design-vue';
import { CloseOutlined, QuestionCircleFilled } from '@ant-design/icons-vue';
import CUpload from '@/components/CUpload.vue';
import CDelModal from '@/components/CDelModal.vue';
import router from '@/router';
import { getToken } from '@/plugins/cookie';
import http from '@/api/control/comment';
import { useRoute } from 'vue-router';
import { useDebounce } from '@/hooks/useDebounce'; //防抖


export default /*#__PURE__*/_defineComponent({
  __name: 'Comment',
  emits: ['click:close'],
  setup(__props, { emit }) {

const token = getToken();

const aList = List;
const aListItem = List.Item;
const aRadioGroup = Radio.Group;
const aRadio = Radio;
const aInputNumber = InputNumber;
const aUpload = Upload;
const aModal = Modal;
const aTextarea = Input.TextArea;

const studioId = router.currentRoute.value.params.studioId;
const route = useRoute();

const commentRef = ref();

const select = ref();
const options = ref<{ value: number; label: string }[]>([]);
// 获取评论类型

const commentList = () => {
  http.get_comment_type_list({ params: { studio_id: route.params.studioId } }).then((res) => {
    let arr: any = [];
    res.data.data.map((e: { id: number; type_name: string }) => {
      arr.push({
        value: e.id,
        label: e.type_name,
      });
    });
    options.value = arr;
    if (classifyType.value === 1) select.value = options.value[options.value.length - 1].value;
    selseChange();
  });
};
const getCommentTypeList = () => {
  http.get_comment_type_list({ params: { studio_id: route.params.studioId } }).then((res) => {
    let arr: any = [];
    res.data.data.map((e: { id: number; type_name: string }) => {
      arr.push({
        value: e.id,
        label: e.type_name,
      });
    });
    options.value = arr;
    getRobotCommentConfig();
  });
};
getCommentTypeList();

const classifyModal = ref(false);
const classInput = ref('');
const classifyType = ref(); // 1 添加  2 修改
const openClassifyModal = (type: number) => {
  const value: any = options.value.find((e) => e.value === select.value);
  if (type === 2) classInput.value = value.label;
  else classInput.value = '';
  classifyModal.value = true;
  classifyType.value = type;
};
// 添加评论库分类
const addCommentType = useDebounce(() => {
  if (classInput.value === '') {
    message.error('评论库分类不能为空！');
    return;
  } else {
    http
      .add_comment_type({ studio_id: route.params.studioId, type_name: classInput.value })
      .then((res) => {
        message.success(res.data.message);
        commentList();
        classifyModal.value = false;
        classInput.value = '';
        textareaRef.value.focus();
      })
      .catch((err) => err?.data?.error);
  }
});

const data = ref<{ id: number; content: string }[]>([]);
const listLoading = ref(false);
const showInput = ref({});
// 分页
const pageConfig = reactive({
  current: 1, // 当前页
  pageSize: 10, // 每页条数
  totalSize: 0, // 总数
});
//获取评论内容列表
const getCommentList = () => {
  listLoading.value = true;
  http
    .get_comment_list({
      params: {
        page: pageConfig.current,
        page_num: pageConfig.pageSize,
        studio_id: route.params.studioId,
        type_id: select.value,
      },
    })
    .then((res) => {
      data.value = data.value.concat(res.data.data.data);
      data.value.forEach((e) => {
        showInput.value[e.id] = false;
      });
      pageConfig.current = res.data.data.current_page;
      pageConfig.totalSize = res.data.data.total;
      textareaRef.value.focus();
    })
    .finally(() => (listLoading.value = false));
};
const selseChange = () => {
  pageConfig.current = 1;
  data.value = [];
  getCommentList();
  textareaRef.value.focus();
};
const scrollList = () => {
  if (pageConfig.totalSize && data.value.length < pageConfig.totalSize) {
    pageConfig.current = pageConfig.current + 1;
    getCommentList();
  }
};
// 添加评论库内容
const clickAddCommentCon = () => {
  if (textarea.value === '') {
    message.error('评论库内容不能为空！');
    return;
  } else {
    http.add_comment_content({ studio_id: route.params.studioId, content: textarea.value, type_id: select.value }).then((res) => {
      message.success(res.data.message);
      selseChange();
      textarea.value = '';
    });
  }
};

const commentItem = ref();
const inputRef = ref();
const updataCommentCon = (item: { id: number; content: string }) => {
  showInput.value[item.id] = !showInput.value[item.id];
  nextTick(() => {
    inputRef.value.focus();
  });
  commentItem.value = item;
};
// 修改评论库内容
const clickUpdataCommentCon = () => {
  http
    .edit_comment_content({ content: commentItem.value.content, type_id: select.value, id: commentItem.value.id })
    .then((res) => {
      message.success(res.data.message);
      showInput.value[commentItem.value.id] = false;
      selseChange();
    });
};

// 获取身份库列表
const selIdent = ref();
const identOptions = ref<{ value: number; label: string }[]>([]);
const getRobotIdentList = () => {
  http.get_robot_identity_list({ params: { studio_id: route.params.studioId } }).then((res) => {
    let arr: any = [];
    res.data.data.list.map((e: { id: number; identity_name: string }) => {
      arr.push({
        value: e.id,
        label: e.identity_name,
      });
    });
    identOptions.value = arr;
    if (identOptions.value.length > 0) {
      selIdent.value = res.data.data.identity_id;
      getCommentRobotList();
    }
  });
};
getRobotIdentList();

const getRobotList = () => {
  http.get_robot_identity_list({ params: { studio_id: route.params.studioId } }).then((res) => {
    let arr: any = [];
    res.data.data.list.map((e: { id: number; identity_name: string }) => {
      arr.push({
        value: e.id,
        label: e.identity_name,
      });
    });
    identOptions.value = arr;
    if (identType.value === 1) {
      selIdent.value = identOptions.value[identOptions.value.length - 1].value;
      selIdentChange();
    }
  });
};

// 添加身份库
const identModal = ref(false);
const identInput = ref('');
const identType = ref(); // 1 添加  2 修改
const openIdentModal = (type: number) => {
  const value: any = identOptions.value.find((e) => e.value === selIdent.value);
  identModal.value = true;
  identType.value = type;
  if (identType.value === 1) identInput.value = '';
  else identInput.value = value.label;
};
const addRobotIdentity = useDebounce(() => {
  http
    .add_robot_identity({ studio_id: route.params.studioId, identity_name: identInput.value })
    .then((res) => {
      message.success(res.data.message);
      identModal.value = false;
      getRobotList();
    })
    .catch((err) => message.error(err.data.error));
});

// 获取身份库内容列表
const robotList = ref<IDataList[]>([]);
// 分页
const pageRobot = reactive({
  current: 1, // 当前页
  pageSize: 10, // 每页条数
  totalSize: 0, // 总数
});
const getCommentRobotList = () => {
  http
    .get_comment_robot_list({
      params: {
        studio_id: route.params.studioId,
        identity_id: selIdent.value,
        page: pageRobot.current,
        page_num: pageRobot.pageSize,
      },
    })
    .then((res) => {
      robotList.value = robotList.value.concat(res.data.data.data);
      pageRobot.current = res.data.data.current_page;
      pageRobot.totalSize = res.data.data.total;
    });
};

const scrollRobot = () => {
  if (pageRobot.totalSize && robotList.value.length < pageRobot.totalSize) {
    pageRobot.current = pageRobot.current + 1;
    getCommentRobotList();
  }
};
const selIdentChange = () => {
  pageRobot.current = 1;
  robotList.value = [];
  getCommentRobotList();
};

// 添加修改身份库内容列表
const identConModal = ref(false);
const identConType = ref();
const identConIn = ref('');
const identConItem = ref();
const identConImg = ref('');
const identConImgId = ref();
const imgLoading = ref(false);
const openIdentConModal = (type: number, item?: IDataList) => {
  identConModal.value = true;
  identConType.value = type;
  if (item) {
    identConItem.value = item;
    identConImg.value = item.avatar_url;
    identConImgId.value = item.avatar_id;
    identConIn.value = item.name;
  } else {
    identConIn.value = '';
    imageDel();
  }
};

const fileList = ref([]);
const handleChang = (info: FileInfo) => {
  if (info.file?.response?.code === 200) {
    identConImg.value = info.file?.response?.data.url;
    identConImgId.value = info.file?.response?.data.id;
  }
  if (info.file.status === 'uploading') {
    imgLoading.value = true;
    return;
  } else imgLoading.value = false;
  if (info.file.status === 'error') {
    imgLoading.value = false;
    message.error('上传失败');
  }
};
const imageDel = () => {
  identConImg.value = '';
  identConImgId.value = '';
};

const updataIdentContent = useDebounce(() => {
  if (identConType.value === 1) {
    http
      .add_user_comment_robot({
        studio_id: route.params.studioId,
        name: identConIn.value,
        avatar_id: identConImgId.value,
        avatar_url: identConImg.value,
        identity_id: selIdent.value,
      })
      .then((res) => {
        message.success(res.data.message);
        identConModal.value = false;
        selIdentChange();
      })
      .catch((err) => message.error(err.data.error));
  } else {
    http
      .edit_user_review_robot({
        id: identConItem.value.id,
        name: identConIn.value,
        avatar_id: identConImgId.value,
        avatar_url: identConImg.value,
      })
      .then((res) => {
        message.success(res.data.message);
        identConModal.value = false;
        selIdentChange();
      })
      .catch((err) => message.error(err.data.error));
  }
});

const send = ref<ICommConfig>({
  send_type: 0, //发送类型0.自动发送；1.手动发送
  increase_pv: 0, //增长PV量
  pv_send_count: 0, //发送UV量
  time_span: 0, //时间跨度
  ts_send_count: 0, //发送条数
  type_id: 0, //评论库id
});
// 获取机器人评论配置
const getRobotCommentConfig = () => {
  http.get_robot_comment_config({ params: { studio_id: route.params.studioId } }).then((res) => {
    send.value = res.data.data;
    status.value = Boolean(res.data.data.status);
    if (options.value.length > 0) {
      select.value = send.value.type_id;
      getCommentList();
    }
  });
};

//  确定
const saveModal = ref(false);
const opensaveModal = () => {
  saveModal.value = !saveModal.value;
};


const clickSave = useDebounce(() => {
  const form = {
    studio_id: route.params.studioId,
    send_type: send.value.send_type,
    increase_pv: send.value.increase_pv,
    pv_send_count: send.value.pv_send_count,
    time_span: send.value.time_span,
    ts_send_count: send.value.ts_send_count,
    type_id: select.value,
    status: status.value,
    identity_id: selIdent.value,
  };
  http
    .set_robot_comment_config(form)
    .then((res) => {
      message.success(res.data.message);
      opensaveModal();
      emit('click:close');
    })
    .catch((err) => message.error(err?.data.error));
});

const status = ref(false);

const changeStatus = () => {
  const form = {
    studio_id: route.params.studioId,
    status: status.value,
  };
  http
    .set_robot_comment_config(form)
    .then((res) => {
      message.success(res.data.message);
    })
    .catch((err) => {
      message.error(err?.data.error);
      status.value = !status.value;
    });
};

// 删除
const delModal = ref(false);
const delType = ref();
const delListId = ref();
const openDelModal = (type: number, id: number) => {
  delModal.value = true;
  delType.value = type;
  delListId.value = id;
};
const removeListData = useDebounce(() => {
  switch (delType.value) {
    case 1: // 评论库内容删除
      del_comment_content();
      break;
    case 2: // 身份库内容删除
      del_comment_robot();
      break;
  }
});
const del_comment_content = () => {
  http
    .del_comment_content({ params: { studio_id: route.params.studioId, id: delListId.value, type_id: select.value } })
    .then((res) => {
      message.success(res.data.message);
      delModal.value = false;
      selseChange();
    })
    .catch((err) => message.error(err?.data?.error));
};
const del_comment_robot = () => {
  http
    .del_comment_robot({ params: { studio_id: route.params.studioId, id: delListId.value, identity_id: selIdent.value } })
    .then((res) => {
      message.success(res.data.message);
      delModal.value = false;
      selIdentChange();
    })
    .catch((err) => message.error(err?.data?.error));
};
const textarea = ref('');
const textareaRef = ref();
const maxRows = computed(() => {
  if (data.value.length >= 4) return 1;
  else if (data.value.length === 0) return 7;
  else if (data.value.length === 2) return 4;
  else if (data.value.length === 3) return 3;
  else return 6;
});
onMounted(() => {
  textareaRef.value.focus();
});

// 返回
const onBlack = () => {
  emit('click:close');
};

return (_ctx: any,_cache: any) => {
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return (_openBlock(), _createElementBlock("div", {
    class: "comment",
    ref_key: "commentRef",
    ref: commentRef
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_a_switch, {
          checked: status.value,
          "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((status).value = $event)),
          onChange: changeStatus
        }, null, 8, ["checked"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(CloseOutlined), {
          style: {"cursor":"pointer"},
          onClick: onBlack
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", null, [
              _createVNode(_component_a_select, {
                value: select.value,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((select).value = $event)),
                options: options.value,
                class: "content_sel mr-16",
                "get-popup-container": () => commentRef.value,
                onChange: selseChange,
                placeholder: "请添加评论库类型"
              }, null, 8, ["value", "options", "get-popup-container"]),
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (openClassifyModal(1)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("新增评论库")
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                (data.value.length > 0)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass({ list_box: data.value.length >= 4 })
                    }, [
                      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_13, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "list_item flex al ju input",
                            key: item.id
                          }, [
                            (!showInput.value[item.id])
                              ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(item.content), 1))
                              : (_openBlock(), _createBlock(_component_a_input, {
                                  key: 1,
                                  ref_for: true,
                                  ref_key: "inputRef",
                                  ref: inputRef,
                                  value: item.content,
                                  "onUpdate:value": ($event: any) => ((item.content) = $event),
                                  class: "item_txt",
                                  onPressEnter: clickUpdataCommentCon
                                }, null, 8, ["value", "onUpdate:value"])),
                            _createElementVNode("div", _hoisted_15, [
                              _createVNode(_component_svg_icon, {
                                "icon-class": "comment_edit",
                                class: "mr-16 item_add",
                                onClick: ($event: any) => (updataCommentCon(item))
                              }, null, 8, ["onClick"]),
                              _createVNode(_component_svg_icon, {
                                "icon-class": "comment_del",
                                class: "item_add",
                                onClick: ($event: any) => (openDelModal(1, item.id))
                              }, null, 8, ["onClick"])
                            ])
                          ]))
                        }), 128))
                      ])), [
                        [_directive_infinite_scroll, scrollList]
                      ])
                    ], 2))
                  : _createCommentVNode("", true),
                _createVNode(_unref(aTextarea), {
                  ref_key: "textareaRef",
                  ref: textareaRef,
                  value: textarea.value,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((textarea).value = $event)),
                  placeholder: "在此输入评论，换行保存",
                  "auto-size": { minRows: 1, maxRows: _unref(maxRows) },
                  onPressEnter: clickAddCommentCon,
                  class: "list_txt"
                }, null, 8, ["value", "auto-size"])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", null, [
              _createVNode(_component_a_select, {
                value: selIdent.value,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((selIdent).value = $event)),
                options: identOptions.value,
                class: "content_sel mr-16",
                onChange: selIdentChange,
                "get-popup-container": () => commentRef.value,
                placeholder: "请添加身份库类型"
              }, null, 8, ["value", "options", "get-popup-container"]),
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (openIdentModal(1)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("新增身份库")
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _withDirectives((_openBlock(), _createBlock(_unref(aList), {
                size: "small",
                bordered: "",
                "data-source": robotList.value,
                class: "list_c",
                "infinite-scroll-distance": "10"
              }, {
                renderItem: _withCtx(({ item }) => [
                  _createVNode(_unref(aListItem), { class: "a_list_item" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          (item.avatar_url)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                class: "comment_item_img",
                                src: item.avatar_url,
                                alt: ""
                              }, null, 8, _hoisted_24))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_25, _toDisplayString(item.name), 1)
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _createVNode(_component_svg_icon, {
                            "icon-class": "comment_edit",
                            class: "mr-16 item_add",
                            onClick: ($event: any) => (openIdentConModal(2, item))
                          }, null, 8, ["onClick"]),
                          _createVNode(_component_svg_icon, {
                            "icon-class": "comment_del",
                            class: "item_add",
                            onClick: ($event: any) => (openDelModal(2, item.id))
                          }, null, 8, ["onClick"])
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              }, 8, ["data-source"])), [
                [_directive_infinite_scroll, scrollRobot]
              ]),
              _createElementVNode("div", {
                class: "list_add item_add",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (openIdentConModal(1)))
              }, "+ 添加身份")
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _hoisted_28,
        _createElementVNode("div", _hoisted_29, [
          _createVNode(_unref(aRadioGroup), {
            value: send.value.send_type,
            "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((send.value.send_type) = $event)),
            style: {"line-height":"32px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(aRadio), {
                value: 0,
                class: "mr-16"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("自动")
                ]),
                _: 1
              }),
              _createVNode(_unref(aRadio), { value: 1 }, {
                default: _withCtx(() => [
                  _createTextVNode("手动")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"]),
          (send.value.send_type === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                _createTextVNode(" 每增长  "),
                _createVNode(_unref(aInputNumber), {
                  id: "inputNumber",
                  value: send.value.increase_pv,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((send.value.increase_pv) = $event)),
                  min: 1
                }, null, 8, ["value"]),
                _createTextVNode(" pv， 发送  "),
                _createVNode(_unref(aInputNumber), {
                  id: "inputNumber",
                  value: send.value.pv_send_count,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((send.value.pv_send_count) = $event)),
                  min: 1
                }, null, 8, ["value"]),
                _createTextVNode("  条 ")
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _createTextVNode(" 在 "),
                _createVNode(_unref(aInputNumber), {
                  id: "inputNumber",
                  value: send.value.time_span,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((send.value.time_span) = $event)),
                  min: 1
                }, null, 8, ["value"]),
                _createTextVNode(" 秒内，发送  "),
                _createVNode(_unref(aInputNumber), {
                  id: "inputNumber",
                  value: send.value.ts_send_count,
                  "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((send.value.ts_send_count) = $event)),
                  min: 1
                }, null, 8, ["value"]),
                _createTextVNode(" 条 ")
              ]))
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: opensaveModal
        }, {
          default: _withCtx(() => [
            _createTextVNode("开始发送")
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(CDelModal, {
      visible: saveModal.value,
      centered: "",
      close: opensaveModal,
      ok: _unref(clickSave),
      "get-container": () => commentRef.value
    }, {
      title: _withCtx(() => [
        _createTextVNode("是否确认保存 ？")
      ]),
      _: 1
    }, 8, ["visible", "ok", "get-container"]),
    _createVNode(_unref(aModal), {
      visible: classifyModal.value,
      "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((classifyModal).value = $event)),
      title: "添加评论库分类",
      centered: "",
      onOk: _unref(addCommentType),
      "get-container": () => commentRef.value
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_33, [
          _hoisted_34,
          _createVNode(_component_a_input, {
            value: classInput.value,
            "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((classInput).value = $event)),
            placeholder: "请输入内容"
          }, null, 8, ["value"])
        ])
      ]),
      _: 1
    }, 8, ["visible", "onOk", "get-container"]),
    _createVNode(_unref(aModal), {
      visible: identModal.value,
      "onUpdate:visible": _cache[15] || (_cache[15] = ($event: any) => ((identModal).value = $event)),
      title: "添加身份库分类",
      centered: "",
      onOk: _unref(addRobotIdentity),
      "get-container": () => commentRef.value
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_35, [
          _hoisted_36,
          _createVNode(_component_a_input, {
            value: identInput.value,
            "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((identInput).value = $event)),
            placeholder: "请输入内容"
          }, null, 8, ["value"])
        ])
      ]),
      _: 1
    }, 8, ["visible", "onOk", "get-container"]),
    _createVNode(_unref(aModal), {
      visible: identConModal.value,
      "onUpdate:visible": _cache[17] || (_cache[17] = ($event: any) => ((identConModal).value = $event)),
      title: identType.value === 1 ? '添加身份库内容' : '修改身份库内容',
      centered: "",
      onOk: _unref(updataIdentContent),
      "get-container": () => commentRef.value
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_37, [
          _hoisted_38,
          _createVNode(CUpload, {
            "file-list": fileList.value,
            "handle-change": handleChang,
            "image-name": identConImg.value,
            "click-stop": imageDel,
            class: "comment_item_up"
          }, null, 8, ["file-list", "image-name"])
        ]),
        _createElementVNode("div", _hoisted_39, [
          _hoisted_40,
          _createVNode(_component_a_input, {
            value: identConIn.value,
            "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((identConIn).value = $event)),
            placeholder: "请输入内容"
          }, null, 8, ["value"])
        ])
      ]),
      _: 1
    }, 8, ["visible", "title", "onOk", "get-container"]),
    _createVNode(CDelModal, {
      visible: delModal.value,
      centered: "",
      close: () => (delModal.value = false),
      ok: _unref(removeListData),
      "get-container": () => commentRef.value
    }, null, 8, ["visible", "close", "ok", "get-container"])
  ], 512))
}
}

})